var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.66699,
    y: 4.37012,
    width: 16.6664,
    height: 11.2611,
    rx: 1.12611,
    stroke: "#998A7B",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8827 4.93311L10.6545 10.0961C10.2629 10.3758 9.73696 10.3758 9.34542 10.0961L2.11719 4.93311",
    stroke: "#998A7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.288d209c2384e7627cd4aa9bcac013b2.svg";
export { ForwardRef as ReactComponent };